import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AnimatedSection } from '../../../components/AnimatedSection';

export default function Services() {
  const { t } = useTranslation();

  const services = [
    {
      icon: 'ri-code-s-slash-line',
      titleKey: 'svc1_title',
      subtitle: 'Custom System Development',
      path: '/solutions',
      color: 'from-cyan-500/10 to-cyan-500/5',
      border: 'border-cyan-500/20 hover:border-cyan-500/50',
      iconBg: 'bg-cyan-500/10',
      iconColor: 'text-cyan-400',
      descKey: 'svc1_desc',
      featureKeys: ['svc1_f1', 'svc1_f2', 'svc1_f3', 'svc1_f4'],
    },
    {
      icon: 'ri-router-line',
      titleKey: 'svc2_title',
      subtitle: 'Network Infrastructure',
      path: '/infrastructure',
      color: 'from-blue-500/10 to-blue-500/5',
      border: 'border-blue-500/20 hover:border-blue-500/50',
      iconBg: 'bg-blue-500/10',
      iconColor: 'text-blue-400',
      descKey: 'svc2_desc',
      featureKeys: ['svc2_f1', 'svc2_f2', 'svc2_f3', 'svc2_f4'],
    },
    {
      icon: 'ri-shield-keyhole-line',
      titleKey: 'svc3_title',
      subtitle: 'Cybersecurity & Firewall',
      path: '/security',
      color: 'from-emerald-500/10 to-emerald-500/5',
      border: 'border-emerald-500/20 hover:border-emerald-500/50',
      iconBg: 'bg-emerald-500/10',
      iconColor: 'text-emerald-400',
      descKey: 'svc3_desc',
      featureKeys: ['svc3_f1', 'svc3_f2', 'svc3_f3', 'svc3_f4'],
    },
  ];

  return (
    <section className="bg-slate-950 py-24" id="services">
      <div className="max-w-7xl mx-auto px-6">
        <AnimatedSection animation="fade-in">
          <div className="text-center mb-16">
            <span className="text-cyan-400 text-sm font-semibold tracking-widest uppercase">{t('services_badge')}</span>
            <h2 className="text-4xl font-bold text-white mt-3 mb-4">{t('services_title')}</h2>
            <p className="text-slate-400 text-lg max-w-2xl mx-auto">{t('services_desc')}</p>
          </div>
        </AnimatedSection>

        <div className="grid md:grid-cols-3 gap-8">
          {services.map((svc, i) => (
            <AnimatedSection key={svc.titleKey} animation="fade-in" delay={i * 0.1}>
              <div className={`relative bg-gradient-to-b ${svc.color} border ${svc.border} rounded-2xl p-8 transition-all duration-300 hover:-translate-y-1 group`}>
                <div className={`w-14 h-14 flex items-center justify-center ${svc.iconBg} rounded-xl mb-6`}>
                  <i className={`${svc.icon} text-2xl ${svc.iconColor}`}></i>
                </div>
                <h3 className="text-2xl font-bold text-white mb-1">{t(svc.titleKey)}</h3>
                <p className="text-slate-500 text-xs mb-4 tracking-wider">{svc.subtitle}</p>
                <p className="text-slate-400 text-sm leading-relaxed mb-6">{t(svc.descKey)}</p>
                <ul className="space-y-2 mb-8">
                  {svc.featureKeys.map(fk => (
                    <li key={fk} className="flex items-center gap-2 text-slate-300 text-sm">
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-checkbox-circle-line text-cyan-500 text-base"></i>
                      </div>
                      {t(fk)}
                    </li>
                  ))}
                </ul>
                <Link
                  to={svc.path}
                  className="flex items-center gap-2 text-cyan-400 hover:text-cyan-300 text-sm font-medium transition-colors cursor-pointer group-hover:gap-3"
                >
                  {t('learn_more')}
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </Link>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
}
